<template>
  <div class="test-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem to="/tests">试题</shBreadItem>
    </shBread>
  </div>
  <div class="test-banner">
    <TestBanner />
  </div>
  <TestFree />
  <div class="tests-adv">
    <RouterLink target="_blank" to="/video??maID=ma055618&firstCate=180">
      <img src="../../../public/imgs/newslist-广告图-972x90.jpg" alt="" />
    </RouterLink>
  </div>
  <div class="news-tabs">
    <ShTabs v-model="activeName" @click="changeActiveName(activeName)">
      <ShTabsPanel label="考试宝典" name="ma055618"
        ><TestCate v-if="activeName === 'ma055618'" />
      </ShTabsPanel>
      <ShTabsPanel label="阿虎医考" name="ma190727"
        ><TestCate v-if="activeName === 'ma190727'"
      /></ShTabsPanel>
      <ShTabsPanel label="助考之星" name="ma025000"
        ><TestCate v-if="activeName === 'ma025000'"
      /></ShTabsPanel>
    </ShTabs>
  </div>
</template>

<script>
import { ref } from "vue";
import TestBanner from "./compontents/test-banner.vue";

import TestFree from "./compontents/test-free.vue";
import TestCate from "./compontents/test-cate.vue";
import { useRouter, useRoute } from "vue-router";

export default {
  name: "Test",
  components: {
    TestBanner,
    TestFree,
    TestCate,
    //TestZhiYe
  },
  setup() {
    const activeName = ref("ma055618");
    const maID = ref("ma055618");
    const router = useRouter();
    router.push(`tests?maID=${maID.value}`);
    const changeActiveName = (id) => {
      try {
        router.push(`tests?maID=${id}`);
      } catch (error) {
        console.log(error);
      }
    };
    return { activeName, changeActiveName };
  },
};
</script>

<style lang="less" scoped>
.test-bread {
  background: @shColor;
}

.news-tabs {
  width: 1240px;
  margin: 0 auto;
  margin-top: 15px;
}
.test-content {
  display: flex;
  align-items: center;
  width: 1240px;
  margin: 0 auto;
  height: 50px;

  i {
    display: inline-block;
    height: 20px;
    width: 3px;
    background: @shColor;
  }
  .app-header-nav {
    width: 820px;
    display: flex;
    padding-left: 25px;
    position: relative;
    z-index: 998;
    li {
      margin-right: 45px;
      width: 150px;
      text-align: center;
      a {
        font-size: 18px;
        line-height: 45px;
        font-weight: bold;
        height: 45px;
        display: inline-block;
      }
      &:hover {
        a {
          color: @shColor;
          border-bottom: 1px solid @shColor;
        }
      }
      .router-link-exact-active {
        color: @shColor;
        border-bottom: 1px solid @shColor;
      }
    }
  }
}
.tests-adv {
  width: 1240px;
  height: 100px;
  margin: 0 auto;
  img {
    width: 1240px;
  }
}
</style>
